import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import './typography.scss'
import styles from './typography.module.scss'

const variantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  h7: 'div',
  h8: 'div',
  h9: 'div',
  h10: 'div',
  h11: 'div',
  p0: 'p',
  p1: 'p',
  p2: 'p',
  p3: 'p',
  p4: 'p',
  p5: 'p',
  p6: 'p',
  p7: 'p',
  p8: 'p',
  p9: 'p',
  p10: 'p',
  p11: 'p',
  p12: 'p',
  p13: 'p',
  p14: 'p',
  'Header-60': 'h1',
  'Body-20': 'p',
}

const Typography = ({
  children,
  className,
  component,
  variant,
  color = null,
  weight,
  noMargin,
  ...rest
}) => {
  const props = {
    ...rest,
    className: clsx(className, styles.root, {
      [styles[weight]]: weight,
      [styles[variant]]: variant,
      [`color-static-${color}`]: color,
      [styles['no-margin']]: noMargin,
    }),
    children: children,
  }

  if (React.isValidElement(component)) {
    return React.cloneElement(component, {
      ...props,
      ...component.props,
      className: clsx(props.className, component.props.className || {}),
    })
  }

  const Component = component || variantMapping[variant] || 'span'

  return <Component {...props}>{children}</Component>
}

Typography.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.elementType,
  ]),
  variant: PropTypes.string,
  weight: PropTypes.oneOf(['light', 'regular', 'medium', 'bold']),
  noMargin: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  color: PropTypes.string,
}

Typography.defaultProps = {
  variant: 'p1',
}

export default Typography
